import {
	Button, Table
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { getInspectionApplications } from '../../actions/inspectionApplication';
import { GET_INSPECTIONAPPLICATION_DETAIL } from '../../actions/types';
import { baseButtonStyles } from '../../assets/baseStyles';
import {
	Container, InspectionFilter, Loading, Title
} from '../../components';
import { INSPECTORSAPPLICATIONS_DETAIL_ROUTE, NEW_INSPECTIONAPPLICATIONS_ROUTE } from '../../routing/paths';
import { inspectionApplicationsColumn } from '../../utils/inspectionsColumns';
import { TITLE_LEVEL } from '../../utils/constants';
import { initialFilters, localeText, status } from '../../utils/utils';

import {
	useQueryParams,
	StringParam,
	DateParam
} from 'use-query-params';

const InspectionApplicationsScreen = () => {
	const [filters, setFilters] = useState(initialFilters);
	const inspectionApplications = useSelector((state) => state.inspectionApplications.inspectionApplications);
	const isLoadingInspectionApplications = useSelector((state) => state.inspectionApplications.isLoadingInspectionApplications);
	const history = useHistory();
	const dispatch = useDispatch();
	const [query, setQuery] = useQueryParams({
		currentStatus: StringParam,
		creatorFullName: StringParam,
		inspectionType: StringParam,
		inspectorFullName: StringParam,
		inspectorInternalCode: StringParam,
		upCode: StringParam,
		endDate: StringParam,
		startDate: StringParam,
		createdAt: StringParam,
	});

	useEffect(() => {
		dispatch(getInspectionApplications({ ...query }));
	}, []);

	const handleChangeFiltersQuery = (flts) => {
		setFilters(flts);

		dispatch(getInspectionApplications({ ...flts }));

		setQuery(
			{ ...flts },
			'push')
	};

	const handleDetailOtherTab = (id) => {
		window.open(INSPECTORSAPPLICATIONS_DETAIL_ROUTE.replace(':id', id), "_blank");
	}
	const handleDetail = (id) => {
		history.push(INSPECTORSAPPLICATIONS_DETAIL_ROUTE.replace(':id', id));
	}
	return (
		<Container>
			<Title level={TITLE_LEVEL}>Solicitudes de inspección</Title>
			<InspectionFilter onChange={handleChangeFiltersQuery} oldForm={query} status={status} />
			<div>
				<Table
					showSizeChanger={false}
					scroll={{ x: 750 }}
					columns={inspectionApplicationsColumn}
					rowKey={(record) => record.id}
					dataSource={inspectionApplications.map((inspectionApplication) => ({
						...inspectionApplication,
						getDetail: () => handleDetail(inspectionApplication.id),
						getDetailOtherTab: () => handleDetailOtherTab(inspectionApplication.id),
					}))}
					loading={{ spinning: isLoadingInspectionApplications, indicator: <Loading /> }}
					locale={localeText}
				/>
			</div>
			<Button type="primary" style={baseButtonStyles}>
				<Link to={NEW_INSPECTIONAPPLICATIONS_ROUTE}>Cargar Solicitud</Link>
			</Button>
		</Container>
	);
};

export default InspectionApplicationsScreen;

